/**
 * Created by richardlovejoy on 2/9/17.
 */

const path = require('path');

// TODO : this should be replaced by the value of DEPLOY_TARGET in webpack.config.js

// constants
const ScreenDims = {

  PORTRAIT_SAFE_ZONE_WIDTH: 768,
  PORTRAIT_SAFE_ZONE_HEIGHT: 928,
  LANDSCAPE_SAFE_ZONE_WIDTH: 1024,
  LANDSCAPE_SAFE_ZONE_HEIGHT: 672
};

export default {

  assetScale: 1,
  imageFolder: path.join('assets/image', STATE_INITIALS),
  imageSharedFolder: 'assets/image',
  fontFolder: 'assets/font',
  meshFolder: 'assets/mesh',
  allowExit: (STATE_INITIALS !== 'demo'),
  lottery: STATE_INITIALS,
  minWidthLandscape: ScreenDims.LANDSCAPE_SAFE_ZONE_WIDTH,
  minHeightLandscape: ScreenDims.LANDSCAPE_SAFE_ZONE_HEIGHT,
  minWidthPortrait: ScreenDims.PORTRAIT_SAFE_ZONE_WIDTH,
  minHeightPortrait: ScreenDims.PORTRAIT_SAFE_ZONE_HEIGHT,
  alwaysShowHelp: true,
  currency: 'USD',
  currencyUnitDivisor: 1,
  numBalls: 10,
  promotionLink: window.fbPage,

  protect: false,
  live: false,
  version: '1.1.0',
  debug: false,//(process.env.NODE_ENV !== 'production'),
  showFPS: (process.env.NODE_ENV !== 'production'),
  enableQuickRotate: false,

  facebookAppId: '2221718758047202',
  facebookApiVersion: 'v7.0',
  linkForShare: 'https://skeeball.local',
  shareSubject: 'Accept my challenge',
  shareMessageTpl: 'Try this cool game!',
  shareMessageWithScoreTpl: 'I got <%- score %> in this cool game. Can you get more?'
};




// WEBPACK FOOTER //
// ./app/src/constants/Config.js